import { ProductService } from 'src/app/features/product/product.service'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import moment from 'moment-mini'
import { combineLatest, Observable, of, Subscription as SubsRxjs } from 'rxjs'
import {
  catchError,
  filter,
  map,
  shareReplay,
  take,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { AppState } from 'src/app/core/core.state'
import { environment } from 'src/environments/environment'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Actions, ofType } from '@ngrx/effects'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { UserRoleHelperService } from '../../../shared/services/user-role-helper.service'
import { configurationOptionSelectors } from '../../configuration-option/configuration-option.selectors'
import { Course } from '../../course/course'
import { courseSelectors } from '../../course/course.selectors'
import { Member, MemberStatus } from '../../member/member'
import { Product } from '../../product/product'
import { productSelectors } from '../../product/product.selectors'
import { Role, RolesType } from '../../role/role'
import { roleSelectors } from '../../role/role.selectors'
import { userRoleActions } from '../../role/user-role/user-role.actions'
import { Sale, StatusCode } from '../../sale/sale'
import { saleActions } from '../../sale/sale.actions'
import { saleSelectors } from '../../sale/sale.selectors'
import { subscriberActions } from '../../subscription/subscriber/subscriber.actions'
import { subscriberSelectors } from '../../subscription/subscriber/subscriber.selectors'
import { Subscription } from '../../subscription/subscription'
import { subscriptionSelectors } from '../../subscription/subscription.selectors'
import { CartItem, CartItemType } from '../cart-item/cart-item'
import { cartItemActions } from '../cart-item/cart-item.actions'
import { cartItemSelectors } from '../cart-item/cart-item.selectors'
import { CartItemService } from '../cart-item/cart-item.service'
import { productActions } from '../../product/product.actions'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { Step03UserDetailsModalComponent } from '../../shop/ticketing/step03-user-details-modal/step03-user-details-modal.component'
import { UserRole } from '../../role/user-role/user-role'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { NotificationService } from 'src/app/core/notification.service'
import { courseActions } from '../../course/course.actions'
import { UtilityService } from 'src/app/core/utility.service'
import { TicketingService } from '../../shop/ticketing/ticketing.service'
import { authActions } from 'src/app/core/auth/auth.actions'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { AppRoutesNS } from 'src/app/app-routes.namespace'
import { LocalStorageKeys } from '../../../core/local-storage.keys'
import { LocalStorageService } from '../../../core/local-storage.service'
import { FamilyMember } from '../../family/family-members/family-member'
import { FamilyMemberService } from '../../family/family-members/family-member.service'
import { AdminFeeProductService } from 'src/app/shared/services/admin-fee-product.service'
import { cartRequiresAuthentication } from '../cart-item/unauthenticated-shopping.util'
import { ConfigOptionsKeys } from 'src/app/shared/constants'
import { CustomerCategoryNamePipe } from 'src/app/shared/pipes/customer-category-name.pipe'
import { TranslateService } from '@ngx-translate/core'

@UntilDestroy()
@Component({
  selector: 'cart-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss'],
  providers: [CustomerCategoryNamePipe]
})
export class CartShowComponent implements OnInit, OnDestroy {
  private subscriptions$: SubsRxjs[] = []
  public cartItems$: Observable<CartItem[]>
  public cartItemsTotal$: Observable<number>
  public cartItemsUnauthenticated$: Observable<Partial<CartItem>[]>
  public cartItemCount$: Observable<number>
  public cartItemUnauthenticatedCount$: Observable<number>
  public isLoading$: Observable<boolean>
  public member$: Observable<Member>
  public productEntities$: Observable<Dictionary<Product>>
  public productEntities: Dictionary<Product>
  public subscriptionEntities$: Observable<Dictionary<Subscription>>
  public courseEntities$: Observable<Dictionary<Course>>
  public courseEntities: Dictionary<Course>
  public pendingSale$: Observable<Sale>
  public roleEntities$: Observable<Dictionary<Role>>
  public shopModuleConfig = environment.moduleConfigs.shopModule
  public bookingModuleConfig = environment.moduleConfigs.bookingModule
  public organizationModuleConfig = environment.moduleConfigs.organizationModule
  public RolesType = RolesType
  public lastAddedCartItem: CartItem
  public bsModalRef: BsModalRef
  public userRoles$: Observable<UserRole[]>
  public form: UntypedFormGroup
  public isOrderNumberEnable =
    environment.moduleConfigs.paymentModule.orderNumber
  public moment: moment.Moment
  public siteId: number
  public confirmButtonIsDisabled: boolean = false
  private isCreateSale: boolean = false
  private coursesIdsInCartItem = []
  private productsIdsInCartItem = []
  public selectedLanguage$: Observable<string>
  public cartItemBasePrices = {}
  public appRoutesNS = AppRoutesNS
  public familyMembers$: Observable<FamilyMember[]>
  public adminFeeProductId$: Observable<number | null>
  private cartItemQuantityFallbackLabel$: Observable<string>
  private cartItemQuantityLabelCache = new Map<string, Observable<string>>()

  constructor(
    private utilityService: UtilityService,
    private store: Store<AppState>,
    public cartItemService: CartItemService,
    public productService: ProductService,
    private actions$: Actions,
    public router: Router,
    public userRoleHelperService: UserRoleHelperService,
    private modalService: BsModalService,
    public fb: UntypedFormBuilder,
    private ticketingservice: TicketingService,
    public configurationService: ConfigurationService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    public familyMemberService: FamilyMemberService,
    private adminFeeProductService: AdminFeeProductService,
    private customerCategoryNamePipe: CustomerCategoryNamePipe
  ) {}

  ngOnDestroy() {
    this.subscriptions$.filter((s) => Boolean(s)).map((s) => s.unsubscribe())
  }

  ngOnInit() {
    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: 'cartModule.cart',
        url: AppRoutesNS.Cart.CART,
        showBackArrow: false,
        titleName: 'cartModule.cart'
      })
    )
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.adminFeeProductId$ = this.adminFeeProductService.adminFeeProductId$
    this.member$ = this.store.select(authSelectors.selectMember)

    this.member$.pipe(take(1)).subscribe((member) => {
      const delcom_unAuthenticatedCarItems = this.localStorageService.getItem(
        LocalStorageKeys.UN_AUTHENTICATED_CART_ITEMS
      )

      if (
        member &&
        delcom_unAuthenticatedCarItems &&
        moment().diff(
          JSON.parse(atob(delcom_unAuthenticatedCarItems))?.time,
          'minutes'
        ) <= 5
      ) {
        let productIds = []
        let courseIds = []
        let subscriptionIds = []
        JSON.parse(atob(delcom_unAuthenticatedCarItems))?.data[
          'ticketing'
        ]?.forEach((data) => productIds.push(data.productId))
        JSON.parse(atob(delcom_unAuthenticatedCarItems))
          ?.data['not_ticketing']?.filter(
            (item) => item.type == CartItemType.PRODUCT
          )
          ?.forEach((data) => productIds.push(data.productId))

        productIds = [...new Set(productIds)]
        courseIds = JSON.parse(atob(delcom_unAuthenticatedCarItems))
          ?.data['not_ticketing']?.filter(
            (item) => item.type == CartItemType.COURSE
          )
          ?.map((data) => data.courseId)
        courseIds = [...new Set(courseIds)]
        subscriptionIds = JSON.parse(atob(delcom_unAuthenticatedCarItems))
          ?.data['not_ticketing']?.filter(
            (item) => item.type === CartItemType.SUBSCRIPTION
          )
          ?.map((data) => data.subscriptionId)
        subscriptionIds = [...new Set(subscriptionIds)]
        this.localStorageService.removeItem(
          LocalStorageKeys.UN_AUTHENTICATED_CART_ITEMS
        )
        this.ticketingservice.fetchingToLocalStoreDate(
          productIds,
          courseIds,
          subscriptionIds
        )

        if (
          !this.localStorageService.getItem(
            LocalStorageKeys.LOAD_PARTIAL_MEMBER
          )
        ) {
          this.ticketingservice.createCarItemsToLocalStoreData(
            delcom_unAuthenticatedCarItems,
            member
          )
          this.store.dispatch(authActions.loadMember({ member: member }))
        }

        this.store.dispatch(cartItemActions.resetPartials())

        // this.ticketingservice.makeCartItem(delcom_unAuthenticatedCarItems)

        this.localStorageService.removeItem(LocalStorageKeys.SHOW_MODAL)
      } else if (!member && delcom_unAuthenticatedCarItems) {
        this.localStorageService.setItem(LocalStorageKeys.SHOW_MODAL, 'true')
        this.store.dispatch(cartItemActions.resetPartials())
        this.ticketingservice.createCarItemsToLocalStoreData(
          delcom_unAuthenticatedCarItems,
          member
        )
      } else {
        this.localStorageService.removeItem(LocalStorageKeys.SHOW_MODAL)
        this.localStorageService.removeItem(
          LocalStorageKeys.UN_AUTHENTICATED_CART_ITEMS
        )
      }
      this.store.dispatch(
        cartItemActions.seTicketingClickingContinueShopping({
          clickShopping: false
        })
      )
    })
    this.localStorageService.removeItem(LocalStorageKeys.LOAD_PARTIAL_MEMBER)
    this.cartItems$ = this.store.select(cartItemSelectors.selectAll).pipe(
      map((carItems) => {
        const sortedCarItems = carItems.sort((a, b) =>
          a.params === null || b.params === null
            ? -1
            : a.params?.startDate === null || b.params?.startDate == null
              ? -1
              : moment(a.params?.startDate) < moment(b.params?.startDate)
                ? -1
                : 1
        )

        return sortedCarItems
      })
    )

    this.cartItemCount$ = this.store.select(cartItemSelectors.selectCount)
    this.cartItemsUnauthenticated$ = this.store.select(
      cartItemSelectors.selectPartials
    )
    this.cartItemUnauthenticatedCount$ = this.store.select(
      cartItemSelectors.selectCountUnauthenticated
    )
    this.cartItemsTotal$ = this.cartItemService.getCartItemsTotal$()

    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.subscriptionEntities$ = this.store.select(
      subscriptionSelectors.selectEntities
    )
    this.courseEntities$ = this.store.select(courseSelectors.selectEntities)
    this.familyMembers$ = this.familyMemberService.getAll()
    this.form = this.fb.group({
      orderNumber: [null, []]
    })

    combineLatest([
      this.productEntities$,
      this.cartItemsUnauthenticated$,
      this.cartItems$,
      this.member$,
      this.store.select(courseSelectors.selectEntities)
    ])
      .pipe(untilDestroyed(this))
      .subscribe(
        ([
          productEntities,
          cartItemsUnauthenticated,
          cartItems,
          member,
          courseEntities
        ]) => {
          const cartItemsProductsToFetch =
            !member || member.status == MemberStatus.GUEST
              ? cartItemsUnauthenticated.filter(
                  (item) => item?.productId && !productEntities[item?.productId]
                )
              : cartItems.filter(
                  (item) => item?.productId && !productEntities[item?.productId]
                )

          let productsIds = []
          const cartItemToMap =
            cartItemsProductsToFetch.length > 0
              ? cartItemsProductsToFetch
              : cartItems
          cartItemToMap.forEach((cart) => {
            if (!this.productsIdsInCartItem.includes(cart.productId)) {
              this.productsIdsInCartItem.push(cart.productId)
              productsIds.push(cart.productId)
            }
            if (
              cart?.params?.bookableLinkedProductId &&
              !this.productsIdsInCartItem.includes(
                cart?.params?.bookableLinkedProductId
              )
            ) {
              this.productsIdsInCartItem.push(
                cart?.params?.bookableLinkedProductId
              )
              productsIds.push(cart.params.bookableLinkedProductId)
            }
            if (
              cart?.params?.bookableProductId &&
              !this.productsIdsInCartItem.includes(
                cart?.params?.bookableProductId
              )
            ) {
              this.productsIdsInCartItem.push(cart.params.bookableProductId)
              productsIds.push(cart?.params?.bookableProductId)
            }
          })
          if (productsIds?.length > 0) {
            this.productService
              .getAllMany(
                RequestQueryBuilder.create({
                  search: { id: { [CondOperator.IN]: productsIds } },
                  join: ['childProducts']
                })
              )
              .pipe(take(1))
              .subscribe()
          }

          const cartItemCourseIds = cartItems
            .map((item) => item?.courseId)
            .filter((item) => Boolean(item))

          if (
            cartItemCourseIds?.length &&
            Object.values(courseEntities)?.length &&
            JSON.stringify(this.coursesIdsInCartItem) !==
              JSON.stringify(cartItemCourseIds)
          ) {
            this.coursesIdsInCartItem = cartItemCourseIds
            this.store.dispatch(
              courseActions.fetchMany({
                params: RequestQueryBuilder.create({
                  search: { id: { [CondOperator.IN]: cartItemCourseIds } },
                  join: { field: 'bookings' }
                })
              })
            )
          }
        }
      )
    this.isLoading$ = combineLatest([
      this.store.select(cartItemSelectors.selectIsLoading),
      this.store.select(subscriberSelectors.selectIsLoading),
      this.store.select(saleSelectors.selectIsLoading)
    ]).pipe(map(([a, b, c]) => a || b || c))

    this.member$
      .pipe(
        filter((member) => Boolean(member)),
        take(1)
      )
      .subscribe((member) => {
        this.fetchCartItems(member?.id)
        this.fetchPendingSales(member?.id)
        this.loadFamilyMemberSubscribers(member)
        this.actions$
          .pipe(
            ofType(cartItemActions.upsertMany),
            take(1),
            timeout(5000),
            catchError(() => of(null))
          )
          .subscribe((action) => {
            if (!action) {
              return
            }
            for (let cartItem of action.entities) {
              if (cartItem.productId) {
                this.store.dispatch(
                  productActions.fetchMany({
                    params: RequestQueryBuilder.create({
                      search: {
                        id: cartItem.productId
                      },
                      join: [
                        { field: 'linkedSubscriptions' },
                        { field: 'translations' }
                      ]
                    })
                  })
                )
              }
            }
          })
        this.store.dispatch(
          userRoleActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: { userId: member?.id }
            })
          })
        )
      })

    this.pendingSale$ = this.store.select(saleSelectors.selectAll).pipe(
      map((sales) =>
        sales.filter((sale) => {
          return (
            sale.statusCode == StatusCode.INFLIGHT &&
            moment(sale.modificationDate).diff(moment(), 'minutes') < 45
          )
        })
      ),

      map((sales) => sales?.[0])
    )

    this.roleEntities$ = this.store.select(roleSelectors.selectEntities)

    this.userRoles$ = this.userRoleHelperService.getUserRoles$(
      [],
      false,
      false,
      false,
      true
    )

    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(untilDestroyed(this))
      .subscribe((pUr) => {
        this.siteId = pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        this.cartItemsTotal$ = this.cartItemService.getCartItemsTotal$()
      })
    this.store
      .select(
        configurationOptionSelectors.selectByKey,
        `online_payments_pos_product_id`
      )
      .pipe(
        take(1),
        filter((configurationOption) => Boolean(configurationOption)),
        map((configurationOption) => Number(configurationOption.value)),
        filter((posProductId) => Boolean(posProductId))
      )
      .subscribe((posProductId) => {
        this.store.dispatch(
          productActions.fetchOneById({
            id: posProductId
          })
        )
      })
    const showModal = this.localStorageService.getItem(
      LocalStorageKeys.SHOW_MODAL
    )
    if (showModal != null) {
      this.cartItemsUnauthenticated$.pipe(take(1)).subscribe((cartItems) => {
        this.bsModalRef = this.modalService.show(
          Step03UserDetailsModalComponent,
          {
            ignoreBackdropClick: false,
            initialState: {
              showDirectlyRegisterButton: cartRequiresAuthentication(cartItems)
            }
          }
        )
      })
    }

    this.store
      .select(cartItemSelectors.selectAll)
      .pipe(untilDestroyed(this), withLatestFrom(this.productEntities$))
      .subscribe(([cartItems, productEntities]) => {
        const didChargeBasePriceResourceProductIds: string[] = []

        if (!productEntities) {
          return
        }
        this.cartItemBasePrices = []
        for (const cartItem of cartItems) {
          const product =
            productEntities[
              cartItem?.params?.bookableLinkedProductId ??
                cartItem?.params?.bookableProductId
            ]

          const basePriceKey = `${cartItem?.params?.startDate}-${cartItem?.params?.bookableProductId}`

          if (
            product &&
            product.allowAsLinkedProduct &&
            product.allowChooseCategory &&
            product.basePrice &&
            cartItem.params?.bookableProductId &&
            !didChargeBasePriceResourceProductIds.includes(basePriceKey)
          ) {
            didChargeBasePriceResourceProductIds.push(basePriceKey)
            this.cartItemBasePrices[
              `${cartItem?.id}-${cartItem?.params?.startDate}-${cartItem?.params?.bookableProductId}`
            ] = product.basePrice
          }
        }
      })
  }

  public getCartItemBasePrice(cartItem: CartItem) {
    if (!cartItem || !cartItem.params?.bookableProductId) {
      return 0
    }

    const key = `${cartItem?.id}-${cartItem?.params?.startDate}-${cartItem.params?.bookableProductId}`

    if (this.cartItemBasePrices[key]) {
      return this.cartItemBasePrices[key]
    }
    return 0
  }

  public getCartItemQuantityLabel$(
    cartItem: CartItem,
    productEntities?: Dictionary<Product>
  ): Observable<string> {
    if (!cartItem) {
      return this.getQuantityFallbackLabel$()
    }

    const rawCategory: unknown = cartItem.category
    const category = Number(rawCategory)

    if (
      cartItem.subscriptionId &&
      (rawCategory === null ||
        rawCategory === undefined ||
        (typeof rawCategory === 'string' && rawCategory.trim() === '') ||
        !Number.isFinite(category))
    ) {
      return this.getQuantityFallbackLabel$()
    }

    if (rawCategory !== null && !(category >= 0)) {
      return this.getQuantityFallbackLabel$()
    }

    const siteId = this.getCartItemProductSiteId(cartItem, productEntities)
    const cacheKey = this.getCartItemQuantityLabelCacheKey(category, siteId)
    const cachedLabel$ = this.cartItemQuantityLabelCache.get(cacheKey)

    if (cachedLabel$) {
      return cachedLabel$
    }

    const label$ = combineLatest([
      this.customerCategoryNamePipe.transform(category, siteId),
      this.getQuantityFallbackLabel$()
    ]).pipe(
      map(([categoryName, quantityLabel]) => {
        if (categoryName) {
          return categoryName
        } else {
          return quantityLabel
        }
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    )

    this.cartItemQuantityLabelCache.set(cacheKey, label$)

    return label$
  }

  private getCartItemProductId(cartItem: CartItem): number | undefined {
    if (cartItem?.params?.bookableLinkedProductId) {
      return cartItem.params.bookableLinkedProductId
    } else if (cartItem?.productId) {
      return cartItem.productId
    } else {
      return undefined
    }
  }

  private getCartItemProductSiteId(
    cartItem: CartItem,
    productEntities?: Dictionary<Product>
  ): number | undefined {
    if (!productEntities) {
      return undefined
    }

    const productId = this.getCartItemProductId(cartItem)

    if (!productId) {
      return undefined
    }

    const product = productEntities[productId]

    if (product) {
      return product.siteId
    } else {
      return undefined
    }
  }

  private getCartItemQuantityLabelCacheKey(
    category: number,
    siteId?: number
  ): string {
    return `${category}-${siteId}`
  }

  private getQuantityFallbackLabel$(): Observable<string> {
    if (this.cartItemQuantityFallbackLabel$) {
      return this.cartItemQuantityFallbackLabel$
    }

    this.cartItemQuantityFallbackLabel$ = this.translateService
      .stream('shopModule.quantity')
      .pipe(shareReplay({ bufferSize: 1, refCount: true }))

    return this.cartItemQuantityFallbackLabel$
  }

  public onRemove(cartItem: CartItem) {
    this.member$
      .pipe(
        filter((member) => Boolean(member)),
        take(1)
      )
      .subscribe((member) => {
        this.fetchCartItems(member?.id)
      })

    this.actions$
      .pipe(
        ofType(cartItemActions.upsertMany),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe((action) => {
        const entityIds = action.entities.map((item) => item.id)

        if (!entityIds.includes(cartItem.id)) {
          return this.store.dispatch(
            cartItemActions.removeOne({ id: cartItem.id })
          )
        }

        this.store
          .select(productSelectors.selectEntities)
          .pipe(take(1), withLatestFrom(this.cartItems$))
          .subscribe(([productEntities, cartItems]) => {
            const isOtherProduct =
              !productEntities[cartItem?.productId]?.bookable &&
              !productEntities[cartItem?.productId]?.allowAsLinkedProduct
            if (
              !cartItem.params?.invitedGuests?.length &&
              !cartItem.params?.invitedMemberEmails?.length &&
              !cartItem.params?.invitedOthers?.length &&
              cartItem?.productId &&
              !productEntities[cartItem?.productId]?.bookerMustBeParticipant &&
              !isOtherProduct &&
              cartItems.length > 1
            ) {
              this.notificationService.emit(
                'alerts.cartItemCannotBeRemoved',
                'warning'
              )
            } else {
              this.store.dispatch(
                cartItemActions.deleteOne({ id: cartItem.id })
              )
            }
          })
      })
  }

  public onRemoveUnauthenticated(cartItem: CartItem) {
    this.store.dispatch(cartItemActions.setLoading({ isLoading: true }))

    this.store
      .select(productSelectors.selectEntities)
      .pipe(take(1), withLatestFrom(this.cartItems$))
      .subscribe(([productEntities, cartItems]) => {
        const isOtherProduct =
          !productEntities[cartItem?.productId].bookable &&
          !productEntities[cartItem?.productId].allowAsLinkedProduct
        if (
          !cartItem.params?.invitedGuests?.length &&
          !cartItem.params?.invitedMemberEmails?.length &&
          !cartItem.params?.invitedOthers?.length &&
          cartItem?.productId &&
          !productEntities[cartItem?.productId]?.bookerMustBeParticipant &&
          !isOtherProduct &&
          cartItems.length > 1
        ) {
          this.notificationService.emit(
            'alerts.cartItemCannotBeRemoved',
            'warning'
          )
        } else {
          this.store.dispatch(
            cartItemActions.deleteOneCartItemUnauthenticated({
              id: cartItem.id
            })
          )
        }
      })
  }

  public onClickCreateSale() {
    this.confirmButtonIsDisabled = true

    let shouldStopForAuthentication = false
    this.member$
      .pipe(take(1), withLatestFrom(this.cartItemsUnauthenticated$))
      .subscribe(([member, cartItemsUnauthenticated]) => {
        const shouldShowAuthenticationOnlyModal = cartRequiresAuthentication(
          cartItemsUnauthenticated
        )
        shouldStopForAuthentication =
          !member ||
          (member.status === MemberStatus.GUEST &&
            shouldShowAuthenticationOnlyModal)

        if (shouldStopForAuthentication) {
          this.confirmButtonIsDisabled = false
          this.localStorageService.setItem(LocalStorageKeys.SHOW_MODAL, 'true')
          this.bsModalRef = this.modalService.show(
            Step03UserDetailsModalComponent,
            {
              ignoreBackdropClick: false,
              initialState: {
                showDirectlyRegisterButton: shouldShowAuthenticationOnlyModal
              }
            }
          )
        }
      })

    if (shouldStopForAuthentication) {
      return
    }

    if (this.form.invalid && this.isOrderNumberEnable) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })

      console.log('%cForm is invalid', 'color: red; font-weight: bold;')
      this.confirmButtonIsDisabled = false
      return
    }
    this.store.dispatch(cartItemActions.setLoading({ isLoading: true }))

    this.member$
      .pipe(
        filter((member) => Boolean(member)),
        take(1)
      )
      .subscribe((member) => {
        this.fetchCartItems(member?.id)
      })

    this.actions$
      .pipe(
        ofType(cartItemActions.upsertMany),
        take(1),
        withLatestFrom(this.store.select(cartItemSelectors.selectAll)),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe(([action, cartItems]) => {
        if (action?.entities?.length == 0) {
          this.store.dispatch(cartItemActions.resetState())
          this.notificationService.emit('alerts.expiredCartItemsAll', 'warning')
          return
        }

        if (action?.entities?.length == cartItems.length) {
          this.createSale()
          return
        }

        const entityIds = action.entities.map((item) => item.id)

        for (let cartItem of cartItems) {
          if (cartItem.productId) {
            this.store.dispatch(
              productActions.fetchMany({
                params: RequestQueryBuilder.create({
                  search: {
                    id: cartItem.productId
                  },
                  join: [
                    { field: 'linkedSubscriptions' },
                    { field: 'translations' }
                  ]
                })
              })
            )
          }
          if (!entityIds.includes(cartItem.id)) {
            this.store.dispatch(cartItemActions.removeOne({ id: cartItem.id }))
          }
        }

        this.notificationService.emit('alerts.expiredCartItemsSome', 'warning')
      })
  }

  private fetchPendingSales(memberId: number) {
    if (!memberId) {
      return
    }

    this.store
      .select(
        configurationOptionSelectors.selectByKeyWithType(
          ConfigOptionsKeys.ALLOW_PENDING_REQUIRED_SALE_SKIPPING
        )
      )
      .pipe(take(1))
      .subscribe((allowPendingRequiredSaleSkipping) => {
        const statuses = [StatusCode.INFLIGHT]

        if (!allowPendingRequiredSaleSkipping) {
          statuses.push(StatusCode.PENDING_REQUIRED)
        }

        this.store.dispatch(
          saleActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                customerPersonId: memberId,
                statusCode: {
                  [CondOperator.IN]: statuses
                }
              },
              join: [
                { field: 'payments' },
                { field: 'saleItems' },
                { field: 'saleItems.product' },
                { field: 'saleItems.product.documents' },
                { field: 'saleItems.product.translations' },
                { field: 'saleItems.booking' },
                { field: 'saleItems.booking.product' }
              ]
            })
          })
        )
      })
  }

  private createSale() {
    this.store
      .select(cartItemSelectors.selectAll)
      .pipe(
        take(1),
        withLatestFrom(
          this.store.select(
            configurationOptionSelectors.selectByKey,
            `sales_person`
          ),
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole)
        )
      )
      .subscribe(([cartItems, salesPersonIdConfigOption, selectedUserRole]) => {
        console.log(`Creating sale with user role ${selectedUserRole}`)

        if (!this.isCreateSale) {
          this.isCreateSale = true
          this.subscriptions$.push(
            this.member$
              .pipe(
                take(1),
                withLatestFrom(
                  this.productEntities$,
                  this.store.select(subscriptionSelectors.selectEntities),
                  this.courseEntities$
                )
              )
              .subscribe(
                ([
                  member,
                  productEntities,
                  subscriptionEntities,
                  courseEntities
                ]) => {
                  let siteId = this.configurationService.getSiteId(
                    cartItems ?? [],
                    productEntities,
                    subscriptionEntities,
                    courseEntities,
                    this.siteId
                  )

                  const filteredAndMappedCartItems = cartItems
                    .filter((cartItem) => Boolean(cartItem.amount))
                    .map((cartItem) => ({
                      productId: cartItem?.params?.bookableLinkedProductId
                        ? cartItem?.params?.bookableLinkedProductId
                        : cartItem?.productId
                          ? cartItem?.productId
                          : null,
                      subscriptionId: cartItem?.subscriptionId ?? null,
                      courseId: cartItem?.courseId ?? null,
                      quantity: cartItem.amount,
                      params: cartItem.params,
                      bookingId: cartItem.params?.bookingId,
                      customerCategory: cartItem?.category,
                      siteId: siteId
                    }))

                  this.store.dispatch(
                    saleActions.createOne({
                      entity: {
                        siteId: siteId,
                        salesPersonId:
                          parseInt(salesPersonIdConfigOption?.value) ??
                          member.id,
                        customerPersonId: member.id,
                        organizationId: selectedUserRole?.organizationId,
                        orderNumber: this.form.controls.orderNumber.value,
                        posId: this.utilityService.getPosId(),
                        saleItems: filteredAndMappedCartItems
                      }
                    })
                  )
                  this.actions$
                    .pipe(
                      ofType(
                        saleActions.upsertMany,
                        saleActions.createOneFailed,
                        saleActions.updateOneById,
                        saleActions.upsertOne
                      ),
                      take(1),
                      catchError(() => of(null))
                    )
                    .subscribe((action) => {
                      if (!action) {
                        console.error('Failed to create sale')
                        return false
                      }

                      if (action.type == saleActions.createOneFailed({}).type) {
                        this.isCreateSale = false
                        this.store.dispatch(
                          cartItemActions.setLoading({ isLoading: false })
                        )
                        this.fetchPendingSales(member?.id)

                        console.warn('Backend denied sale creation')

                        this.confirmButtonIsDisabled = false
                        return false
                      }

                      const sale = action
                        ? (action as any).entities
                          ? (action as any).entities[0]
                          : (action as any).entity
                            ? (action as any).entity
                            : null
                        : null

                      if (!sale) {
                        console.error('Failed to create sale before timeout')
                        this.confirmButtonIsDisabled = false
                        return false
                      }

                      this.router.navigate([`/sales/${sale.id}/checkout`])
                    })
                }
              )
          )
        }
      })
  }

  public onEmptyCartClick() {
    // fetch the cart items again to see if cron job has removed the items
    this.member$
      .pipe(
        filter((member) => Boolean(member)),
        take(1)
      )
      .subscribe((member) => {
        this.fetchCartItems(member?.id)
      })

    this.actions$
      .pipe(
        ofType(cartItemActions.upsertMany),
        take(1),
        withLatestFrom(this.store.select(cartItemSelectors.selectAll)),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe(([action, cartItems]) => {
        if (action?.entities?.length == 0) {
          this.store.dispatch(cartItemActions.resetState())
          return
        }

        if (action?.entities?.length == cartItems.length) {
          this.store.dispatch(cartItemActions.emptyCart())
          return
        }

        const entityIds = action.entities.map((item) => item.id)

        for (let cartItem of cartItems) {
          if (cartItem.productId) {
            this.store.dispatch(
              productActions.fetchMany({
                params: RequestQueryBuilder.create({
                  search: {
                    id: cartItem.productId
                  },
                  join: [
                    { field: 'linkedSubscriptions' },
                    { field: 'translations' }
                  ]
                })
              })
            )
          }
          if (!entityIds.includes(cartItem.id)) {
            this.store.dispatch(cartItemActions.removeOne({ id: cartItem.id }))
          }
        }

        this.store.dispatch(cartItemActions.emptyCart())
      })
  }

  public onEmptyCartClickUnauthenticated() {
    this.store.dispatch(cartItemActions.emptyCartUnauthenticated())
  }

  public getPrice(
    productEntities: Dictionary<Product>,
    productId: number,
    cartItem: CartItem,
    total: number,
    type?: string
  ) {
    const product = productEntities[productId]
    let guestPrice: number = 0
    let otherPrice: number = 0
    if (!type) {
      if (cartItem?.category) {
        const price = Number(total)
        return { price }
      }

      guestPrice =
        Number(product?.guestPrice ?? 0) *
        Number(cartItem?.params?.invitedGuests?.length ?? 0)

      otherPrice =
        Number(product?.otherInvitePrice ?? 0) *
        Number(cartItem?.params?.invitedOthers?.length ?? 0)
    }

    let price = Number(total)
    if (cartItem.courseId && cartItem.params) {
      price = Number(total) + guestPrice + otherPrice
    } else {
      price = Number(total) - guestPrice - otherPrice
    }

    return { price }
  }

  public backToShopping() {
    this.cartItems$.pipe(take(1)).subscribe((cartItems) => {
      if (cartItems?.length) {
        this.lastAddedCartItem = cartItems.reduce((prev, current) =>
          prev.id > current.id ? prev : current
        )

        if (!this.lastAddedCartItem?.params?.startDate) {
          if (this.lastAddedCartItem.type == CartItemType.TICKET) {
            return this.router.navigateByUrl('/shop/ticketing')
          } else {
            return this.router.navigateByUrl(
              `/shop/items?type=${this.lastAddedCartItem.type}`
            )
          }
        }
      }
      return this.router.navigateByUrl('/shop')
    })
  }

  public goToLogin() {
    this.localStorageService.setItem(LocalStorageKeys.SHOW_MODAL, 'true')
    this.bsModalRef = this.modalService.show(Step03UserDetailsModalComponent, {
      ignoreBackdropClick: false
    })
  }

  public getPriceOfGuestInvite(cartItem: CartItem): number {
    let price = null
    this.productEntities$.pipe(take(1)).subscribe((productEntities) => {
      let fallthroughProduct =
        productEntities[cartItem?.params?.bookableProductId]
      let categoryPrice =
        productEntities[
          cartItem?.params?.bookableLinkedProductId ?? cartItem?.productId
        ]?.allowChooseCategory && cartItem?.category
          ? productEntities[cartItem?.params?.bookableLinkedProductId]?.[
              `category${cartItem?.category}Price`
            ] !== null
            ? productEntities[cartItem?.params?.bookableLinkedProductId]?.[
                `category${cartItem?.category}Price`
              ]
            : fallthroughProduct?.[`category${cartItem?.category}Price`]
          : productEntities[cartItem?.params?.bookableLinkedProductId]
                ?.price !== null
            ? productEntities[cartItem?.params?.bookableLinkedProductId]?.price
            : productEntities[cartItem?.params?.bookableProductId]?.price

      if (
        productEntities[
          cartItem?.params?.bookableLinkedProductId ?? cartItem?.productId
        ]?.paymentPerParticipant
      ) {
        if (cartItem?.params?.invitedGuests?.length) {
          const targetPrice = productEntities[
            cartItem?.params?.bookableLinkedProductId ?? cartItem?.productId
          ]?.allowChooseCategory
            ? categoryPrice
            : productEntities[cartItem?.params?.bookableLinkedProductId]
                  ?.guestPrice !== null
              ? productEntities[cartItem?.params?.bookableLinkedProductId]
                  ?.guestPrice
              : productEntities[cartItem?.params?.bookableProductId]?.guestPrice
          price = targetPrice ?? 0
        }
      } else {
        if (cartItem?.params?.invitedGuests?.length) {
          price =
            productEntities[cartItem?.params?.bookableLinkedProductId]
              ?.guestPrice !== null
              ? productEntities[cartItem?.params?.bookableLinkedProductId]
                  ?.guestPrice
              : productEntities[cartItem?.params?.bookableProductId]?.guestPrice
        }
      }
    })
    return price
  }

  public getLimitTimeCartItem(cartItem: CartItem) {
    return moment(cartItem.createdAt).add(1, 'h').toISOString()
  }

  public printScreen() {
    window.print()
  }

  public getInvitedGuestCategory(cartItem: CartItem) {
    if (!cartItem) {
      return null
    }

    let allowChooseCategory

    this.productEntities$.pipe(take(1)).subscribe((productEntities) => {
      allowChooseCategory =
        productEntities?.[cartItem.productId]?.allowChooseCategory
    })

    if (!allowChooseCategory) {
      return null
    }

    return cartItem.params.invitedGuests[0]?.category ?? null
  }

  private fetchCartItems(memberId) {
    this.store.dispatch(
      cartItemActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            memberId: memberId
          },
          join: [
            { field: 'product' },
            // { field: 'product.linkedSubscriptions' },
            { field: 'product.translations' },
            { field: 'subscription' },
            { field: 'subscription.translations' },
            { field: 'course' },
            { field: 'course.translations' },
            { field: 'course.product' }
            //{ field: 'course.product.linkedSubscriptions' }
          ]
        })
      })
    )
  }

  private loadFamilyMemberSubscribers(member: Member) {
    this.familyMemberService
      .isFamilyFeatureEnabled()
      .pipe(take(1))
      .subscribe((isEnabled) => {
        if (!isEnabled || !member?.id) {
          return
        }

        this.familyMemberService
          .getAll()
          .pipe(take(1))
          .subscribe((familyMembers) => {
            const familyMemberIds = familyMembers
              .filter((familyMember) => familyMember.memberId !== member.id)
              .map((familyMember) => familyMember.memberId)

            if (!familyMemberIds.length) {
              return
            }

            this.store.dispatch(
              subscriberActions.fetchActiveGlobalForMembers({
                memberIds: familyMemberIds
              })
            )
          })
      })
  }

  public getLandingPageRedirect(): string {
    return AppRoutesNS.Booking.ACTIVITIES
  }

  public getOtherInvitePrice(
    productEntities: Dictionary<Product>,
    cartItem: CartItem
  ): number {
    const activity = cartItem?.params?.bookableLinkedProductId
      ? productEntities[cartItem?.params?.bookableLinkedProductId]
      : null
    const resource = cartItem?.params?.bookableProductId
      ? productEntities[cartItem?.params?.bookableProductId]
      : null

    if (activity?.otherInvitePrice !== null) {
      return activity?.otherInvitePrice
    }
    if (resource?.otherInvitePrice !== null) {
      return resource?.otherInvitePrice
    }
    // ((productEntities$ | async)[
    //   cartItem.params?.bookableLinkedProductId
    //     ? cartItem.params?.bookableLinkedProductId
    //     : cartItem.productId
    // ]?.otherInvitePrice
    //   ? (productEntities$ | async)[
    //       cartItem.params?.bookableLinkedProductId
    //         ? cartItem.params?.bookableLinkedProductId
    //         : cartItem.productId
    //     ]?.otherInvitePrice
    //   :0
    // )

    return 0
  }
}
